import { getStoreValue, updateStoreValue } from '@core/utils/store';
import { TUTORIAL_TIP_MESSAGES_TYPES, WESOG_STORE_PARAMS } from '@core/constants/STORE';
import { TRIGGER_CLOSE_TUTORIAL_TIP_EVENT } from '@core/constants/TUTORIAL_TIP';

/**
 * Handle the close button event by updating the store and calling the close callback.
 * @param {Function} closeCallback - The callback function to execute after updating the store
 * @returns {void}
 */
export function handleCloseButtonsEvent(closeCallback) {
    const tutorialTipsStore = getStoreValue(WESOG_STORE_PARAMS.TUTORIAL_TIPS);
    tutorialTipsStore[TUTORIAL_TIP_MESSAGES_TYPES.DEFAULT_REPORT] = false;

    updateStoreValue(WESOG_STORE_PARAMS.TUTORIAL_TIPS, tutorialTipsStore);

    if (typeof closeCallback === 'function') {
        closeCallback();
    }
}

/**
 * Dispatch the close tutorial event.
 * @returns {void}
 */
export function dispatchCloseTutorialEvent() {
    document.dispatchEvent(new CustomEvent(TRIGGER_CLOSE_TUTORIAL_TIP_EVENT));
}

/**
 * Check if the tutorial should close based on mouse leave position.
 * @param {MouseEvent} event - The mouse event
 * @param {DOMRect} bounds - The bounding rectangle of the tutorial container
 * @returns {boolean} True if the tutorial should close, false otherwise
 */
export function shouldCloseOnMouseLeave(event, bounds) {
    const mouseX = event.clientX;
    const mouseY = event.clientY;

    return mouseX < bounds.left || mouseX > bounds.right || mouseY > bounds.bottom;
}
